export const density = {
  tight: {
    cardPadding: 14,
    sectionGap: 40,
    gridGap: 8,
    buttonPadding: '8px 16px',
    buttonSmPadding: '5px 11px',
    buttonXsPadding: '3px 8px',
    inputPaddingY: 7,
    inputPaddingX: 10,
    listItemPadding: '9px 12px',
    buttonFontSize: 12,
    buttonSmFontSize: 11,
    buttonXsFontSize: 10,
  },
  comfortable: {
    cardPadding: 20,
    sectionGap: 56,
    gridGap: 12,
    buttonPadding: '11px 22px',
    buttonSmPadding: '7px 14px',
    buttonXsPadding: '4px 10px',
    inputPaddingY: 9,
    inputPaddingX: 12,
    listItemPadding: '12px 16px',
    buttonFontSize: 13,
    buttonSmFontSize: 12,
    buttonXsFontSize: 11,
  },
} as const;

export type DensityMode = keyof typeof density;
export type DensityTokens = typeof density.tight;
